// import React, { useEffect, useState } from "react";
// import { Link, useNavigate } from 'react-router-dom';
// import axios from 'axios';
// import { API_BASE_URL, ACCESS_TOKEN_NAME, Image_Base_Url, ACCESS_Role_ID, ACCESS_Log_In_User_Id } from '../constants/apiConstants';
// import OwlCarousel from "react-owl-carousel";
// import "owl.carousel/dist/assets/owl.carousel.css";
// import "owl.carousel/dist/assets/owl.theme.default.css";
// // import placeIcon from "../assets/img/add/add_img.png";
// import placeIcon from "../assets/img/icon/monitor.svg";
// import delhiIcon from "../assets/img/place/delhi.png";
// import bangaloreIcon from "../assets/img/place/bangalore.png";
// import hyderabadIcon from "../assets/img/place/hyderabad.png";
// import puneIcon from "../assets/img/place/pune.png";
// import mumbaiIcon from "../assets/img/place/mumbai.png";


// // Import images

// const TopPlacesSlider = () => {
//   const [personalInfo, setPersonalInfo] = useState([]);
//   const [profileImg, setProfileImg] = useState([]);
//   const [loading, setLoading] = useState(true);  // Handle loading state

//   const fetchTopPlaces = async () => {
//     try {
//       const response = await axios.get(`${API_BASE_URL}/getExploreTopStudyPlaces`);
//       setProfileImg(response.data.data.personalInfo);
//     } catch (err) {
//       console.error("Error fetching data:", err);
//     } finally {
//       setLoading(false);
//     }
//   };

//   useEffect(() => {
//     fetchTopPlaces();
//   }, []); 
//   return (
//     <div className="institute-slider-container department-slider">
//       {/* Show loader if data is still being fetched */}
      
//         <OwlCarousel
//           className="owl-theme"
//           loop
//           margin={15}
//           nav
//           autoplay
//           autoplayTimeout={3000}
//           responsive={{
//             0: { items: 1 },
//             600: { items: 2 },
//             1000: { items: 4 },
//           }}
//         >
//             <div class="pd_20" key="1">
//               <h4 class="ft_head"><a href="">Delhi/NCR</a></h4>
//               <div class="department-item">
//                 <div class="department-icon">
//                   <img src={delhiIcon} alt="" />
//                 </div>
//               </div>
//             </div>
//             <div class="pd_20" key="2">
//               <h4 class="ft_head"><a href="">Banglore</a></h4>
//               <div class="department-item">
//                 <div class="department-icon">
//                   <img src={bangaloreIcon} alt="" />
//                 </div>
//               </div>
//             </div>
//             <div class="pd_20" key="3">
//               <h4 class="ft_head"><a href="">Hydrabad</a></h4>
//               <div class="department-item">
//                 <div class="department-icon">
//                   <img src={hyderabadIcon} alt="" />
//                 </div>
//               </div>
//             </div>
//             <div class="pd_20" key="4">
//               <h4 class="ft_head"><a href="">Pune</a></h4>
//               <div class="department-item">
//                 <div class="department-icon">
//                   <img src={puneIcon} alt="" />
//                 </div>
//               </div>
//             </div>
//             <div class="pd_20" key="5">
//               <h4 class="ft_head"><a href="">Mumbai</a></h4>
//               <div class="department-item">
//                 <div class="department-icon">
//                   <img src={mumbaiIcon} alt="" />
//                 </div>
//               </div>
//             </div>
//         </OwlCarousel>
//       </div>
//   );
// };

// export default TopPlacesSlider;


import React, { useEffect, useState } from "react";
import axios from "axios";
import OwlCarousel from "react-owl-carousel";
import {
  API_BASE_URL,
  Image_Base_Url,
} from "../constants/apiConstants";
import "owl.carousel/dist/assets/owl.carousel.css";
import "owl.carousel/dist/assets/owl.theme.default.css";

const TopPlacesSlider = () => {
  const [places, setPlaces] = useState([]);
  const [loading, setLoading] = useState(true);

  const fetchTopPlaces = async () => {
    try {
      const response = await axios.get(`${API_BASE_URL}/getExploreTopStudyPlaces`);
      if (response.data) {
        setPlaces(response.data);
      }
    } catch (err) {
      console.error("Error fetching top places:", err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchTopPlaces();
  }, []);

  return (
    <div className="institute-slider-container department-slider">
      {!loading && (
        <OwlCarousel
          className="owl-theme"
          loop
          margin={15}
          nav
          autoplay
          autoplayTimeout={3000}
          responsive={{
            0: { items: 1 },
            600: { items: 2 },
            1000: { items: 4 },
          }}
        >
          {places.map((place, index) => (
            <div className="pd_20" key={place.id || index}>
              <h4 className="ft_head">
                <a href="#">{place.title}</a>
              </h4>
              <div className="department-item">
                <div className="department-icon">
                  <img
                    src={`${Image_Base_Url}${place.media_image_path}`}
                    alt={place.title}
                    style={{ width: "100%", height: "auto", objectFit: "cover" }}
                  />
                </div>
              </div>
            </div>
          ))}
        </OwlCarousel>
      )}
    </div>
  );
};

export default TopPlacesSlider;
